import React from "react";
import { useHistory } from "react-router-dom";
import useTreatments from "../../store/treatments/treatmentsContext";
import PrimaryButton from "../../components/Buttons/PrimaryButton";
import useApp from "../../store/app/appContext";
import StripeCheckoutModal from "./StripeCheckoutModal";
import CreditCardInputForm from "./CreditCardInputForm";
import BillingInputForm from "./BillingInputForm";
import PaymentItemsTable from "./PaymentItemsTable";
import CheckoutModal from "./CheckoutModal";

function TreatmentTransactionCheckout({ treatmentInfo }) {
  const {
    appState: { user },
  } = useApp();

  const {
    payForTreatmentTransaction,
    generateStripePaymentMethod,
  } = useTreatments();

  const treatmentId = treatmentInfo._id;

  const [cardDetails, setCardDetails] = React.useState({
    cvv: '',
    card_name: '',
    expiry_date: '',
    card_number: '',
  })

  const [billingInfo, setBillingInfo] = React.useState({
    country: user.location.country,
    city: user.location.city,
    address: user.location.address,
    postal_code: user.location.postal_code,
  })

  const history = useHistory();

  const [formError, setFormError] = React.useState({
    field: '',
    msg: ''
  });
  
  const [showCheckout, setShowCheckout] = React.useState(false);

  
  const [selectedPaymentItems, setSelectedPaymentItems] = React.useState([]);  
  const [totalPaymentAmount, setTotalPaymentAmount] = React.useState(0);
  
  const validatePaymentData = () => {
    let element;
    if (
      cardDetails.cvv.length !== 3 || 
      cardDetails.card_number.length !== 19 || 
      !cardDetails.card_name || 
      cardDetails.expiry_date.length !== 5
    )  {
      setFormError({ field: 'card', msg: 'Please fill all card information fields correctly' });
      element = document.getElementById('card');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return false;
    }
    if (
      !billingInfo.address ||
      !billingInfo.city ||
      !billingInfo.postal_code ||
      !billingInfo.country
    ) {
      setFormError({ field: 'billing', msg: 'Please fill all billing information fields correctly' });
      element = document.getElementById('billing');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return false;
    }
    return true;
  }
  
  const formatPaymentData = () => {
    const expiry_date = cardDetails.expiry_date.split("/");
    const expiry_month = expiry_date[0];
    let expiry_year = expiry_date[1];
    const current_century = new Date()
      .getFullYear()
      .toString()
      .replace(/.{0,2}$/, "");
    expiry_year = current_century + expiry_year;
    //TODO: Fix Stripe Country integration
    const formattedData = {
      'billing_details[address][city]': billingInfo.city,
      'billing_details[address][country]': 'US' || billingInfo.country,
      'billing_details[address][postal_code]': billingInfo.postal_code,
      'billing_details[address][line1]': billingInfo.address,
      'billing_details[name]': cardDetails.card_name,
      'billing_details[email]': user?.email,
      'card[number]': cardDetails.card_number.replaceAll("-", ""),
      'card[exp_month]': expiry_month,
      'card[exp_year]': expiry_year,
      'card[cvc]': cardDetails.cvv,
      'type': "card",
    };
    return formattedData;
  }
  
  const initiatePayment = async () => {
    setFormError({
      field: '',
      msg: ''
    })
    const dataToGeneratePaymentMethod = formatPaymentData();
    const paymentMethod = await generateStripePaymentMethod(dataToGeneratePaymentMethod);  
    const dataToProcessPayment = {
      paymentMethodId: paymentMethod.data.id,
      transactionsId: selectedPaymentItems.map(t => t._id),
    };
    return payForTreatmentTransaction(treatmentId, dataToProcessPayment);
  };

  const goBackToTreatment = () => {
    history.push("/manage-treatments/details", { treatmentInfo });
  };

  const handlePayClick = () => {
    const correctData = validatePaymentData();
    if (correctData) setShowCheckout(true);
  }

  return (
    <div>
      <div>
        <CreditCardInputForm 
          setCardDetails={setCardDetails} 
          formError={formError} 
          cardDetails={cardDetails}
        />
        <BillingInputForm 
          user={user} 
          formError={formError} 
          setBillingInfo={setBillingInfo} 
          billingInfo={billingInfo} 
        />
        <div className="w-full rounded bg-white shadow flex flex-col p-10 mt-6">
          <PaymentItemsTable 
            treatmentInfo={treatmentInfo}
            setTotalPaymentAmount={setTotalPaymentAmount}
            setSelectedPaymentItems={setSelectedPaymentItems}
            selectedPaymentItems={selectedPaymentItems}
            handlePayClick={handlePayClick}
            totalPaymentAmount={totalPaymentAmount}
          />
          
        </div>
        <div className='flex flex-row-reverse mt-8'>
          <PrimaryButton onClick={() => goBackToTreatment()} text="Go Back"/>
        </div>
      </div>
      <CheckoutModal 
        showCheckout={showCheckout} 
        setShowCheckout={setShowCheckout}
        initiatePayment={initiatePayment}
        treatmentId={treatmentId}
        setSelectedPaymentItems={setSelectedPaymentItems}
        setTotalPaymentAmount={setTotalPaymentAmount}
      />
    </div>
  );
}

export default TreatmentTransactionCheckout;